export const ROUTE_NAMES = {
  ORG_BASE: 'org-base',
  ORG_MAIN_HOME: 'org-main-home',
  ARCHIVE: 'archive',
  ORG_SELECT: 'org-select',
  YOUR_WORK: 'your-work',
  INBOX: 'inbox',
  GOALS: 'goals',
  TEAM: 'team',
  PROJECT: 'project',
  ALL_GOALS: 'all-goals',
  EXPLORE_ALL: 'explore-all',
  LISTS: 'lists',
  ALL_INITIATIVES: 'all-initiatives',
  ALL_ACTIVITY: 'all-activity',
  GOAL: 'goal',
  KR: 'kr',
  INITIATIVE: 'initiative',
  INITIATIVE_OLD: 'initiative-old',
  EDIT_GOAL: 'edit-goal',
  NEW_GOAL: 'new-goal',
  NEW_GOAL_GLOBAL: 'new-goal-global',
  USER: 'user',
  SIGN_UP: 'sign-up',
  CREATE_ORG: 'create-org',
  COLLECT_REFERENCE: 'collect-reference',
  JOIN_ORG: 'join-org',
  INVITE_TO_ORG: 'invite-to-org',
  INVITATION_SIGN_UP: 'invitation-sign-up',
  HOW_NORTH_WORKS: 'how-north-works',
  REQUEST_INVITE: 'request-invite',
  SET_PASSWORD: 'set-password',
  LOGIN: 'login',
  LOGOUT: 'logout',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  SET_PROFILE: 'set-profile',
  INVITATION: 'invitation',
  NOT_FOUND: '404',
  ADMIN_PANEL: 'admin-panel',
  NOTIFICATIONS: 'notifications',
  IDEA_LIST: 'idea-list',
  IDEA: 'idea',
  ORG_OLD_ROUTE: 'org-old-route',
  NORTH_UNI: 'north-uni',
  MY_WORK: 'my-work',
  DOORWAY: 'door-way',
  AUTHORIZE_GOOGLE: 'authorize-google',
  API: 'api'
}
